import { createContext, useState, useEffect } from 'react';
import {
    CognitoUserPool,
    CognitoUserAttribute,
    CognitoUser,
} from 'amazon-cognito-identity-js';

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    // Set cognito username string as user
    const [user, setUser] = useState(() => {
        const storedState = localStorage.getItem('user');
        return storedState ? storedState : null
    });

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const storedState = localStorage.getItem('isAuthenticated');
        return storedState ? storedState : false;
    });

    const [accessToken, setAccessToken] = useState(() => {
        const storedState = localStorage.getItem('accessToken');
        return storedState ? storedState : false;
    });

    const poolData = {
        UserPoolId: 'us-east-1_4yVA2N8NW', // Your user pool id here
        ClientId: '6n1roltf2d4o5tb24jrin0qhc', // Your client id here
    };

    // Example: Check for existing login on component mount

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser >= 1) {
            setUser(storedUser);

            var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
            var userData = {
                Username: user,
                Pool: userPool,
            };
            var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
            // Get attributes for an authenticated user
            cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                    console.log(err.message || JSON.stringify(err));
                    setIsAuthenticated(false);
                    return;
                }
                for (var i = 0; i < result.length; i++) {
                    console.log(
                        'attribute ' + result[i].getName() + ' has value ' + result[i].getValue()
                    );
                    setIsAuthenticated(true);
                }
            });
        }
    }, []);


    const register = (username, email, password) => {
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

        var dataEmail = {
            Name: 'email',
            Value: email,
        };

        var attributeEmail = new AmazonCognitoIdentity.CognitoUserAttribute(dataEmail);
        var attributeList = [];
        attributeList.push(attributeEmail);

        userPool.signUp(
            username,
            password,
            attributeList,
            null,
            function (err, result) {
                if (err) {
                    alert(err.message || JSON.stringify(err));
                    return;
                }
                var cognitoUser = result.user;
                console.log('user name is ' + cognitoUser.getUsername());
            }
        );

        setUser(username);
        localStorage.setItem('user', username);
    }

    const verify = (verificationCode) => {

        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: localStorage.getItem('user'),
            Pool: userPool,
        };

        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.confirmRegistration(verificationCode, true, function (err, result) {
            if (err) {
                alert(err.message || JSON.stringify(err));
                return;
            }
            console.log('call result: ', result);
        });

    }


    const login = (username, password) => {
        return new Promise((resolve, reject) => {
            var authenticationData = {
                Username: username,
                Password: password,
            };

            var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
                authenticationData
            );

            var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
            var userData = {
                Username: username,
                Pool: userPool,
            };
            var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {
                    var accessToken = result.getAccessToken().getJwtToken();
                    console.log('Logged in successfully. Received access token.');
                    setUser(username);
                    setIsAuthenticated(true);
                    setAccessToken(accessToken);
                    localStorage.setItem('user', username);
                    localStorage.setItem('isAuthenticated', true);
                    localStorage.setItem('accessToken', accessToken);
                    console.log(localStorage);
                    resolve();
                },

                onFailure: function (err) {
                    alert(err.message || JSON.stringify(err));
                    reject(err);
                },
            });
        });
    }


    const resendVerificationCode = () => {
        // TODO: Update with email
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: localStorage.getItem('user'),
            Pool: userPool,
        };

        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                alert(err.message || JSON.stringify(err));
                return;
            }
            console.log('call result: ' + result);
        });
    }


    const forgotPassword = (username) => {
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: username,
            Pool: userPool,
        };

        localStorage.setItem('user', username);
        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: function (data) {
                // successfully initiated reset password request
                console.log('CodeDeliveryData from forgotPassword: ' + data);
            },
            onFailure: function (err) {
                alert(err.message || JSON.stringify(err));
            }
        });
    }

    const setNewPassword = (verificationCode, newPassword) => {

        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: localStorage.getItem('user'),
            Pool: userPool,
        };

        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onSuccess() {
                console.log('Password confirmed!');
            },
            onFailure(err) {
                alert('Password not confirmed!');
            },
        });
    }


    const logout = () => {
        // Sign out cognito user
        var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
        var userData = {
            Username: user,
            Pool: userPool,
        };
        var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        cognitoUser.signOut();

        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('accessToken');
    };




    return (
        <AuthContext.Provider value={{
            user,
            isAuthenticated,
            accessToken,
            login,
            logout,
            register,
            verify,
            resendVerificationCode,
            forgotPassword,
            setNewPassword
        }}>
            {children}
        </AuthContext.Provider>
    );
};